export default __webpack_public_path__ + "static/media/ComputoriaImageTwo.733211e2.png";